<template>
  <section id="about" class="aboutSection">
    <div cover class="backGroundImage" src="/images/aboutSection.jpg">
      <img class="svg flower-01" src="/images/flowers.svg" />
      <div class="opacity" />
      <div class="content-continer">
        <div class="content">
          <h2>
            <span class="bold">A</span>BOUT
            <span class="bold main-color">R</span>GIFT
          </h2>
          <h4 class="sub-title-font-size">{{ $t("home.about.subTitle") }}</h4>
        </div>
      </div>
      <section class="box"></section>
      <div class="cards-continer">
        <div class="continer">
          <div class="card">
            <h2>{{ $t("home.about.cardOneTitle") }}</h2>
            <p class="sub-title-font-size">
              {{ $t("home.about.cardOneContent") }}
            </p>
          </div>
          <div class="card">
            <h2>{{ $t("home.about.cardTwoTitle") }}</h2>
            <p class="sub-title-font-size">
              {{ $t("home.about.cardTwoContent") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      isLaptop: "isLaptop",
      isTablet: "isTablet",
      isDesktop: "isDesktop",
    }),
  },
};
</script>

<style lang="scss">
</style>
<style scoped lang="scss">
.backGroundImage {
  height: 430px;
  background-image: url("../../../../public/images/aboutSection.jpg");
  background-size: cover;
}
.aboutSection {
  margin-top: 140px;
  position: relative;
}
.flower-01 {
  z-index: 2;
  top: 260px;
  rotate: 0deg;
  right: -50px;
  transform: rotatey(180deg);
}
.opacity {
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 60%);
  position: absolute;
  z-index: 1;
}
.content-continer {
  display: flex;
  justify-content: center;
}
.cards-continer {
  display: flex;
  justify-content: center;
  position: relative;
  top: 270px;
}
.continer {
  max-width: 1600px;
  z-index: 2;
  display: flex;
  padding: 10px;
  gap: 90px;
  flex-direction: row;
}
.card {
  background: rgb(255 255 255 / 90%);
  text-align: start;
  color: $DeepGray;
  flex-basis: 50%;
  padding: 30px 50px 65px;
  box-shadow: 0px 10px 70px 0px rgba(0, 0, 0, 0.2);
  h2 {
    text-align: start;
    margin: 0;
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 30px;
    color: black;
  }
  p {
    font-size: 20px;
    font-weight: 300;
    color: $DeepGray;
  }
}
.content {
  position: absolute;
  z-index: 2;
  text-align: center;
  max-width: 1200px;
  margin-top: 60px;
  h2 {
    margin-bottom: 10px;
  }
}
h2 {
  font-size: 35px;
  text-align: center;
  color: white;
  font-weight: 300;
}
h4 {
  color: white;
  font-weight: 300;
  font-size: 22px;
}
.main-color {
  color: $primaryColor;
}
.bold {
  font-weight: 700;
}
.isLaptop {
  .continer {
    max-width: 1400px !important;
  }
}
.isTablet,
.isMobile {
  section {
    margin-top: 70px !important;
  }
  .continer {
    max-width: 1000px;
    flex-direction: column;
    gap: 30px;
  }
  .card {
    margin: 0px 10px;
    flex-basis: unset;
    padding: 20px 30px 40px;
  }
  h4 {
    font-size: 21px;
    margin: 0px 15px;
  }
}
.isMobile .cards-continer {
  top: 340px;
}
.isMobile {
  .backGroundImage {
    height: 500px;
  }
  p {
    font-size: 18px;
  }
  h2 {
    font-size: 25px;
  }
}
@media only screen and (max-width: 600px) {
  .cards-continer {
    top: 170px !important;
  }
}
</style>